// vimeo autoplay works, BUT, it seems that only one vimeo player can autoplay at a time
// so we need to pause and play based on what video we see

import { getTargetContainersExceptPageOverlay } from '../utility/utility_controller'
import initVimeoSDKPlayers, { playerInstances, destroyDetachedPlayers, wrapPlayerForIframe } from './vimeo_init_sdk_players'

var $iframesOnPage = []
var $iframesOnPageOverlay = []
var isAnyVideoFullscreen = false

var $target = undefined
var lastTypeOfContentThatIsReady = undefined
var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		// Free players whose iframe was removed by the navigation that triggered
		// this content_ready, before wiring up the new page's players.
		destroyDetachedPlayers()

		$target = getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)
		$iframesOnPage = $target.find('.lay-vimeo-autoplay iframe[src*="vimeo.com"]')

		initVimeoSDKPlayers($iframesOnPage)
		
		// Add fullscreen event listeners
		$iframesOnPage.each(function() {
			const player = playerInstances.get(this)
			if (player) {
				player.on('fullscreenchange', function(data) {
					isAnyVideoFullscreen = data.fullscreen
				})
			}
		})
		
		initObserverForPage($iframesOnPage)
		lastTypeOfContentThatIsReady = typeOfContentThatIsReady
	})

	window.laytheme.on('overlayshown', function ($newTarget) {
		$target = $newTarget
		// only do all this once per page overlay:
		if ($target.hasClass('lay-overlay-was-opened-at-least-once')) {
			return
		}
		$iframesOnPageOverlay = $target.find('.lay-vimeo-autoplay iframe[src*="vimeo.com"]')
		initVimeoSDKPlayers($iframesOnPageOverlay)
		
		// Add fullscreen event listeners
		$iframesOnPageOverlay.each(function() {
			const player = playerInstances.get(this)
			if (player) {
				player.on('fullscreenchange', function(data) {
					isAnyVideoFullscreen = data.fullscreen
				})
			}
		})
		
		initObserverForPageOverlay($iframesOnPageOverlay)
	})

	window.laytheme.on('overlayhidden', function () {
		$target = getTargetContainersExceptPageOverlay(lastTypeOfContentThatIsReady)
	})

	// A lazy-loaded Vimeo iframe (Lay Options -> "Use Lazy Loading for Vimeo
	// videos") only gets its src when it scrolls into view — after the
	// content_ready bulk init already ran. Wire the SDK player up now so autoplay
	// and the play/pause-on-scroll observer still apply to it.
	window.laytheme.on('lay_iframe_lazyloaded', function (iframe) {
		if (!iframe || !iframe.closest('.lay-vimeo-autoplay')) {
			return
		}
		if (!/vimeo\.com/.test(iframe.getAttribute('src') || '')) {
			return
		}
		var player = wrapPlayerForIframe(iframe)
		if (player) {
			player.on('fullscreenchange', function (data) {
				isAnyVideoFullscreen = data.fullscreen
			})
		}
		var observer = iframe.closest('.lay-overlay') ? pageOverlayObserver : pageObserver
		if (observer) {
			observer.observe(iframe)
		}
	})
}

// Keep one observer per scope and disconnect the previous one before building a
// new set — content_ready fires repeatedly per navigation, so creating a fresh
// observer each time (and never disconnecting) leaked one observer per fire.
var pageObserver = null
var pageOverlayObserver = null

var initObserverForPageOverlay = function ($vimeoPlayers) {
	if (pageOverlayObserver) {
		pageOverlayObserver.disconnect()
	}
	pageOverlayObserver = new IntersectionObserver(callback, { threshold: 0 })

	// observe elements
	$vimeoPlayers.each(function () {
		if (jQuery(this).is('iframe')) {
			pageOverlayObserver.observe(this)
		}
	})
}

var initObserverForPage = function ($vimeoPlayers) {
	if (pageObserver) {
		pageObserver.disconnect()
	}
	pageObserver = new IntersectionObserver(callback, { threshold: 0 })

	// observe elements
	$vimeoPlayers.each(function () {
		if (jQuery(this).is('iframe')) {
			pageObserver.observe(this)
		}
	})
}

let callback = (entries, observer) => {
	// Don't do anything if we're in fullscreen mode
	if (isAnyVideoFullscreen) {
		return
	}
	
	entries.forEach((entry) => {
		const iframe = entry.target
		if (entry.isIntersecting == true) {
			// we set to dirty in vimeoplayer_custom_controls.js
			if (iframe.dataset.dirty != 'true' && iframe.dataset.ready == 'true') {
				const player = playerInstances.get(iframe)
				if (player) {
					// Check if it's already playing to avoid competing play requests
					player
						.getPaused()
						.then((paused) => {
							if (paused) {
								// Only attempt to play if it's actually paused
								return player.play().catch((error) => {
									if (error.name === 'PlayInterrupted') {
										// If play was interrupted, don't try again
										return
									}
									// For other errors, try one more time after a delay
									return new Promise((resolve) => {
										setTimeout(() => {
											player
												.play()
												.then(resolve)
												.catch((err) => {
													resolve()
												})
										}, 1000)
									})
								})
							}
						})
						.catch((error) => {
							console.error('Error in autoplay sequence:', error)
						})
				}
			} else {
			}
		}
		if (entry.isIntersecting == false) {
			if (iframe.dataset.ready == 'true') {
				const player = playerInstances.get(iframe)
				if (player) {
					player.getPaused().then((paused) => {
						if (!paused) {
							player.pause()
						}
					})
				}
			}
		}
	})
}

var i = function () {
	bindOnContentReady()
}

var vimeoplayer_autoplay = {
	i: i,
}

export default vimeoplayer_autoplay
